import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_protected/(partial-matches)/partial-matches")({
  loader: () => {
    throw redirect({ to: "/partial-matches" });
  },
});
